import { Link } from 'react-router-dom';
import type { BadgeTone } from '@easymoving/ui';

const toneTint: Record<BadgeTone, string> = {
  neutral: 'bg-surface-tint text-graphite',
  petrol: 'bg-petrol-tint text-petrol-deep',
  clay: 'bg-clay-tint text-clay-deep',
  olive: 'bg-olive-tint text-olive',
  amber: 'bg-amber-tint text-amber',
  blue: 'bg-blue-tint text-blue',
  violet: 'bg-violet-tint text-violet',
  rose: 'bg-rose-tint text-rose',
  ink: 'bg-ink text-white',
};

export function StatCard({
  label,
  count,
  tone,
  to,
}: {
  label: string;
  count: number;
  tone: BadgeTone;
  to: string;
}) {
  return (
    <Link
      to={to}
      className={`surface p-3 flex flex-col gap-0.5 hover:elev-pop transition-shadow ${count === 0 ? 'opacity-60' : ''}`}
    >
      <span
        className={`inline-flex w-fit items-center justify-center min-w-7 h-6 px-1.5 rounded-full text-[15px] font-bold tnum ${toneTint[tone]}`}
      >
        {count}
      </span>
      <span className="text-[13px] text-graphite leading-tight mt-1">{label}</span>
    </Link>
  );
}
